import { useEffect, useRef } from "react";

import lottie from "lottie-web";

export const LottieWrapper = ({
  animationData,
  width = "100%",
  height = "100%",
  path = "",
}) => {
  const element = useRef(null);
  const lottieInstance = useRef();

  useEffect(() => {
    if (element.current) {
      lottieInstance.current = lottie.loadAnimation({
        animationData,
        path,
        container: element.current,
      });

      return () => lottieInstance.destroy();
    }
  }, [animationData, path]);
  useEffect(() => {
    return () => {
      console.log("cleaned up");
    };
  }, []);
  return (
    <div style={{ width, height, position: "absolute" }} ref={element}></div>
  );
};
